import { IsString, IsUUID } from 'class-validator';
import { BaseDto } from '../base.dto';
import { UserDto } from '../user.dto';

export class CreateReferralClaimDto {}
export class ReferralClaimDto implements Partial<BaseDto> {
  id: string;
  createdByUser?: UserDto;
  updatedByUser?: UserDto;
  deletedByUser?: UserDto;
  created?: string | Date;
  updated?: string | Date;
  deleted?: string | Date;

  @IsString()
  userId?: string;

  @IsUUID('all')
  referralId?: string;
}
